import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { ProgressBar } from 'react-bootstrap';
import { activity_miniatures_palettes } from '../themes';


function ActivityButton ({name, color, progress, onClick}) {
    let theme;
    
    switch (color){
        case 'green':
            theme = activity_miniatures_palettes.green;
            break;
        case 'blue':
            theme = activity_miniatures_palettes.blue;
            break;
        case 'pink':
            theme = activity_miniatures_palettes.pink;
            break;
        case 'purple':
            theme = activity_miniatures_palettes.purple;
            break;
    }
    
    const progressBarStyle = {
        backgroundColor: theme.pbcolor1,
        height: '12px'
    };
    
    const progressStyle = {
        backgroundColor: theme.pbcolor3
    };
    
    return (
        <div className='activityButton' style={{backgroundImage: `url(${theme.pattern})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}}  onClick={onClick}>
            <div className="button-content">
                <span className="button-name" style={{backgroundColor: theme.textcolor}}>{name}</span>
                <img src={theme.playbutton} alt="Play Button" className="play-button"/>
                <div className="progress-container" style={{backgroundColor: theme.pbcolor2}}>
                    <p className="progress-text m-1">{progress}%</p>
                    <ProgressBar now={progress} className="flex-grow-1" style={progressBarStyle}>
                        <ProgressBar now={progress} style={progressStyle}/>
                    </ProgressBar>
                </div>
            </div>
        </div>
    );
}

export default ActivityButton;
